import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyAhQa7AV_nPLK-WLr3QPe3YAUtg0HveLho",
//   authDomain: "fir-crud-5a1c5.firebaseapp.com",
//   databaseURL: "https://fir-crud-5a1c5-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "fir-crud-5a1c5",
//   storageBucket: "fir-crud-5a1c5.appspot.com",
//   messagingSenderId: "420100749079",
//   appId: "1:420100749079:web:6966e7f2a9fa78fba6a952",
//   measurementId: "G-GG02MN5C61"
// };
const firebaseConfig = {
  apiKey: "AIzaSyAv3RwMxTrd-XVxZ7-FQVy5OZeVEXhX4b8",
  authDomain: "carrat-b291f.firebaseapp.com",
  projectId: "carrat-b291f",
  storageBucket: "carrat-b291f.appspot.com",
  messagingSenderId: "1073850176812",
  appId: "1:1073850176812:web:1c429070ea1706e4630889",
  measurementId: "G-JZTEQKDGS9"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);



 